import React from 'react';
import { withTranslation } from 'react-i18next';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';

const EditArticle = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.edit_article')}
        type="button"
        onClick={onClick}><EditOutlineIcon/></button></span>
)

export default withTranslation('dashboard')(EditArticle);
